<template>
	<router-view/>
	<utils></utils>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import Utils from './Utils.vue'
export default defineComponent({
	components: {
		Utils
	}
})
</script>

<style lang="scss">

</style>
